import { render, staticRenderFns } from "./RatingRow.vue?vue&type=template&id=068ed697&"
import script from "./RatingRow.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RatingRow.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068ed697')) {
      api.createRecord('068ed697', component.options)
    } else {
      api.reload('068ed697', component.options)
    }
    module.hot.accept("./RatingRow.vue?vue&type=template&id=068ed697&", function () {
      api.rerender('068ed697', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/RatingRow/RatingRow.vue"
export default component.exports